import { render, staticRenderFns } from "./BDistributor.vue?vue&type=template&id=08c1d604&"
import script from "./BDistributor.vue?vue&type=script&lang=js&"
export * from "./BDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports